// extracted by mini-css-extract-plugin
export default {"products":"zw-z","card":"Aw-z","oosMessaging":"Bw-z"};